import React from 'react';
import { XIcon } from 'lucide-react';
import { costs } from '../data/landing';
export function Agitation() {
  return <section className="w-full bg-sand" aria-labelledby="costo-titulo" data-id="element-16" data-mp="3l97xxsb1ckp7">
      <div className="mx-auto max-w-content px-6 py-16 md:py-20" data-id="element-17" data-mp="356a4tsohrey">
        <h2 id="costo-titulo" className="max-w-2xl font-display text-2xl font-semibold text-plum sm:text-3xl" data-id="element-18" data-mp="32bpp29o06lj">
          Trabajar sin un protocolo claro tiene un costo alto:
        </h2>

        <ul className="mt-10 divide-y divide-plum/10 border-t border-plum/10" data-id="element-19" data-mp="32jrq0jx0tpyr">
          {costs.map(cost => <li key={cost.title} className="grid grid-cols-1 gap-1 py-5 sm:grid-cols-12 sm:gap-6 sm:py-6" data-id="element-20" data-mp="3gbpwemzcl7r8">
              <div className="flex items-center gap-3 sm:col-span-5" data-id="element-21" data-mp="3bj6j7r4koemy">
                <XIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-clay" data-id="element-22" data-mp="2ntu121r9ow8i" />
                <h3 className="font-sans text-base font-semibold text-plum" data-id="element-23" data-mp="2jr7g8kt0kbkt">
                  {cost.title}
                </h3>
              </div>
              <p className="pl-7 font-sans text-base leading-relaxed text-ink/75 sm:col-span-7 sm:pl-0" data-id="element-24" data-mp="3cnlr62rano5u">
                {cost.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}